import { render, staticRenderFns } from "./Home3Dian8.vue?vue&type=template&id=5f1a43fe&scoped=true"
import script from "./Home3Dian8.vue?vue&type=script&lang=js"
export * from "./Home3Dian8.vue?vue&type=script&lang=js"
import style0 from "./Home3Dian8.vue?vue&type=style&index=0&id=5f1a43fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1a43fe",
  null
  
)

export default component.exports